import Axios from "axios";

const apiPath = window.location.host;

const axiosInstance = Axios.create({
  baseURL: `https://lcdwebappserver20211129191341.azurewebsites.net/cws/LCDCore/`,
});

export default axiosInstance;